





































import { Component, Vue } from 'vue-property-decorator';
import checkout from '@/store/modules/checkout';
import store from '@/store';
import { QuoteAddress } from '@/store/models';

@Component({
    components: {},
})
export default class ShippingInfo extends Vue {
    get address(): QuoteAddress {
        return checkout.shippingAddress;
    }

    get checkoutemail(): string {
        return checkout.email;
    }

    get countryName() {
        const country = store.state.countryData.countries.find((c: any) => c.code === this.address.country_id);
        return country ? country.name : this.address.country_id;
    }

    private editAddress() {
        checkout.flagEditShippingAddress(true);
        this.$router.push({ path: '/checkout/shipping' });
    }
}
